import React from 'react';
import ReactMarkdown from 'react-markdown';
import { graphql } from "gatsby";

import Layout from '../components/Layout';

const GeneralPage = ({data}) => {
  const post = data.strapiGeneralPage;
  return (
    <Layout title={post.Title}>
      <div className="py-8 bg-white">
        <div className="container mx-auto px-12">
          <h2 className="mt-4 text-xl font-semibold">{post.Title}</h2>
          <ReactMarkdown children={post.Content} className="mt-12 mb-8 prose max-w-5xl" />
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query GeneralPageQuery($slug: String) {
    strapiGeneralPage(Slug: {eq: $slug}) {
      Slug
      Title
      Content
    }
  }
`;

export default GeneralPage;